import React, { useState } from 'react';
import { toast } from 'react-toastify';
import PermissionServices from '../../../services/Permission';

const AddPermission = () => {
    const [permissionName, setPermissionName] = useState('');
    const [saving, setSaving] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!permissionName.trim()) {
            toast.error('Permission name is required');
            return;
        }

        setSaving(true);
        try {
            await PermissionServices.createPermission({
                name: permissionName.trim(),
                is_active: true
            });
            toast.success('Permission created successfully');
            setPermissionName('');
            // Close modal
            const modal = document.getElementById('add-permission');
            if (modal) {
                modal.style.display = 'none';
                modal.classList.remove('show');
                document.body.classList.remove('modal-open');
                const backdrop = document.querySelector('.modal-backdrop');
                if (backdrop) {
                    backdrop.remove();
                }
            }
        } catch (error) {
            toast.error('Failed to create permission');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="modal fade" id="add-permission" tabIndex="-1" aria-labelledby="addPermissionModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="addPermissionModalLabel">Add New Permission</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label htmlFor="permissionName" className="form-label">Permission Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="permissionName"
                                    value={permissionName}
                                    onChange={(e) => setPermissionName(e.target.value)}
                                    placeholder="e.g., NewModule_Create"
                                    required
                                />
                                <div className="form-text">
                                    Use format: ModuleName_Action (e.g., Reports_Read, Inventory_Update)
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            <button type="submit" className="btn btn-primary" disabled={saving}>
                                {saving ? 'Creating...' : 'Create Permission'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddPermission;